import { Dialog as BaseDialog } from '@base-ui/react/dialog';

type DialogProps = React.ComponentPropsWithoutRef<typeof BaseDialog.Root>;

function Dialog(props: DialogProps) {
  return <BaseDialog.Root {...props} />;
}

interface DialogTriggerProps extends React.ComponentPropsWithoutRef<typeof BaseDialog.Trigger> {
  className?: string;
}

function DialogTrigger({ className, ...props }: DialogTriggerProps) {
  return <BaseDialog.Trigger className={className} {...props} />;
}

type DialogPortalProps = React.ComponentPropsWithoutRef<typeof BaseDialog.Portal>;

function DialogPortal(props: DialogPortalProps) {
  return <BaseDialog.Portal {...props} />;
}

interface DialogBackdropProps extends React.ComponentPropsWithoutRef<typeof BaseDialog.Backdrop> {
  className?: string;
}

function DialogBackdrop({ className, ...props }: DialogBackdropProps) {
  return <BaseDialog.Backdrop className={className} {...props} />;
}

export interface DialogPopupProps extends React.ComponentPropsWithoutRef<typeof BaseDialog.Popup> {
  className?: string;
}

function DialogPopup({ className, ...props }: DialogPopupProps) {
  return <BaseDialog.Popup className={className} {...props} />;
}

interface DialogTitleProps extends React.ComponentPropsWithoutRef<typeof BaseDialog.Title> {
  className?: string;
}

function DialogTitle({ className, ...props }: DialogTitleProps) {
  return <BaseDialog.Title className={className} {...props} />;
}

interface DialogDescriptionProps extends React.ComponentPropsWithoutRef<
  typeof BaseDialog.Description
> {
  className?: string;
}

function DialogDescription({ className, ...props }: DialogDescriptionProps) {
  return <BaseDialog.Description className={className} {...props} />;
}

interface DialogCloseProps extends React.ComponentPropsWithoutRef<typeof BaseDialog.Close> {
  className?: string;
}

function DialogClose({ className, ...props }: DialogCloseProps) {
  return <BaseDialog.Close className={className} {...props} />;
}

export {
  Dialog,
  DialogTrigger,
  DialogPortal,
  DialogBackdrop,
  DialogPopup,
  DialogTitle,
  DialogDescription,
  DialogClose,
};
